import { Component, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { BottomsheetLayoutComponent } from '@components/bottomsheet-layout/bottomsheet-layout.component';
import { CsIconModule } from '@components/icon';
import { EventLoggerService } from '@services/event-logger-service';

export enum LockedProductType {
  Repair = 'repair',
  Unavailable = 'unavailable',
}

export interface LockedProductBottomsheetData {
  type: LockedProductType;
  productImage: string;
  fixedPrice: number;
  fixedPriceMRP: number;
  discount: number;
  regimenClass: string;
}

@Component({
  selector: 'app-locked-product-bottomsheet',
  imports: [ButtonCtaComponent, BottomsheetLayoutComponent, CsIconModule],
  templateUrl: './locked-product-bottomsheet.component.html',
})
export class LockedProductBottomsheetComponent {
  readonly data: LockedProductBottomsheetData = inject(MAT_BOTTOM_SHEET_DATA);
  readonly LockedProductType = LockedProductType;
  private readonly bottomSheetRef = inject(MatBottomSheetRef<LockedProductBottomsheetComponent>);
  private readonly router = inject(Router);
  private readonly eventLoggerService = inject(EventLoggerService);

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }

  onBuyKit(): void {
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({
      name: 'locked-product-buy-kit',
      type: this.data.type,
      regimenClass: this.data.regimenClass,
      fixedPrice: this.data.fixedPrice,
    }));
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/user'], { queryParams: { tab: 'regimen', class: this.data.regimenClass } });
  }
}
